// @ts-ignore
import * as Fix from "../../dist/fix/fix.js";

// @ts-ignore
_global.Fix = Fix;
